import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Projektmappe — aggregierte Asset-Übersicht im project-detail.tabs-Slot.
 * Renderer ist React.lazy, lädt erst beim Anzeigen des Slots.
 */
const manifest: SkillManifest = {
  key: 'project-portfolio',
  name: 'Projektmappe',
  description:
    'Aggregierte Übersicht aller Projekt-Assets (Dokumente, Medien, Eingänge, Versionen …) mit ZIP-Download.',
  category: 'data',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ],
  enabledByDefault: true,
};

const PortfolioPanel = lazy(() =>
  import('./PortfolioPanel').then((m) => ({ default: m.PortfolioPanel })),
);

export const projectPortfolioSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.tabs': [
      {
        key: 'portfolio-panel',
        order: 35,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId + readOnly
        render: PortfolioPanel,
      },
    ],
  },
};
